import { environment } from '@mg-platform/core/core-util'

export const CONTACT_API_URL = {
  contact: `${environment.apiUrl}/contact`
}
